import {
  getV1ApiUser,
  putV1ApiUser,
  getV1ApiImagesConfig,
  getV1ApiImagesSignature,
  getV1ApiUserMfa,
  postV1ApiUserEmail,
  postV1ApiUserPassword,
  putV1ApiUserEmail,
  deleteV1ApiUserMfa,
} from "@givery-technology/track-account-frontend-sdk/generated-sdk/models";

import {
  UpdateUserProfileInput,
  RequestEmailChangeInput,
  ApplyEmailChangeInput,
  ImagesSignatureParams,
} from "../models";

export const getCurrentUser = async () => {
  const response = await getV1ApiUser();

  return response;
};

export const putCurrentUser = async (data: UpdateUserProfileInput) => {
  const response = await putV1ApiUser(data);

  return response;
};

export const getUserMfa = async () => {
  const response = await getV1ApiUserMfa();

  return response;
};

export const postUserEmail = async (data: RequestEmailChangeInput) => {
  const response = await postV1ApiUserEmail(data);

  return response;
};

export const putUserEmail = async (data: ApplyEmailChangeInput) => {
  const response = await putV1ApiUserEmail(data);

  return response;
};

export const postUserPassword = async () => {
  const response = await postV1ApiUserPassword();

  return response;
};

export const deleteUserMfa = async () => {
  const response = await deleteV1ApiUserMfa();

  return response;
};

export const getImagesConfig = async () => {
  const response = await getV1ApiImagesConfig();

  return response;
};

export const getImagesSignature = async (params: ImagesSignatureParams) => {
  const response = await getV1ApiImagesSignature(params);

  return response;
};
